import React from "react"
import ReactDOM from "react-dom/client"
import ProductTable from "./components/ProductTable"
import SortableTable from "./components/SortableTable"

const COMPONENTS = { ProductTable, SortableTable }
const roots = new WeakMap()

function mountReactComponents() {
  document.querySelectorAll("[data-react-class]").forEach((node) => {
    const name = node.getAttribute("data-react-class")
    const props = JSON.parse(node.getAttribute("data-react-props") || "{}")
    const Component = COMPONENTS[name]
    if (!Component) return

    let root = roots.get(node)
    if (!root) {
      root = ReactDOM.createRoot(node)
      roots.set(node, root)
    }
    root.render(React.createElement(Component, props))
  })
}

function handlePlayersUpdate() {
  const container = document.getElementById("players_data")
  if (!container) return
  const template = container.querySelector("[data-players-update]")
  if (!template) return
  const players = JSON.parse(template.getAttribute("data-players-update"))
  template.remove()
  if (window.__setPlayers) window.__setPlayers(players)
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mountReactComponents)
} else {
  mountReactComponents()
}
document.addEventListener("turbo:load", mountReactComponents)
document.addEventListener("turbo:morph", mountReactComponents)
document.addEventListener("turbo:before-stream-render", (event) => {
  const original = event.detail.render
  event.detail.render = function (streamElement) {
    original(streamElement)
    handlePlayersUpdate()
  }
})
